import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
import { onBeforeUnmount, onMounted, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChartPageThumbnail',
    props: {
        pdf: {},
        page: {},
        width: {},
        height: {}
    },
    setup(__props) {
        const props = __props;
        const canvas = ref(null);
        let renderTask = null;
        onMounted(async () => {
            const page = await props.pdf.getPage(props.page);
            const context = canvas.value?.getContext("2d");
            if (!context)
                return;
            const scale = Math.min(props.width / page.view[2], props.height / page.view[3]);
            renderTask = page.render({ canvasContext: context, viewport: page.getViewport({ scale }) });
            try {
                await renderTask.promise;
            }
            catch {
                // Cancelled while scrolling out of view; the canvas is discarded with the row.
            }
        });
        onBeforeUnmount(() => renderTask?.cancel());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("canvas", {
                ref_key: "canvas",
                ref: canvas,
                width: __props.width,
                height: __props.height,
                class: "chart-page-thumbnail"
            }, null, 8, _hoisted_1));
        };
    }
});
